<template>
  <v-layout
    row
    wrap
    fluid
  >
    <v-flex>
      <v-card class="max-shadow">
        <v-card-title primary-title>
          <div class="headline">
            Edit {{ employee.name }}
          </div>
        </v-card-title>
        <v-form ref="form">
          <v-container
            grid-list-lg
            class="pa-3"
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  ref="name"
                  v-model="employee.name"
                  :rules="[v => !!v || 'Employee Name is required']"
                  autofocus
                  label="Employee Name"
                  required
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  ref="email"
                  v-model="employee.email"
                  :rules="validationRules.email"
                  label="Employee Email"
                  type="email"
                  required
                  disabled
                />
              </v-flex>
              <v-flex
                xs12
                sm6
                d-flex
                align-center
              >
                <div class="subheading pr-1 pb-1">
                  +91
                </div>
                <v-text-field
                  ref="phone"
                  v-model="phoneFormatted"
                  :rules="validationRules.phone"
                  mask="##########"
                  label="Employee Phone"
                  required
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  ref="designation"
                  v-model="employee.designation"
                  label="Designation"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            flat
            @click.stop="$emit('cancel')"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click.stop="_saveEmployee"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import _get from 'lodash/get';

import validationRules from '@/mixins/validation-rules';
import * as libphonenumber from 'libphonenumber-js';
import { firestore } from '@/firebase';

export default {
  name: 'NewEmployee',
  mixins: [validationRules],
  props: {
    employee: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    phoneFormatted: {
      get() {
        const phone = _get(this.employee, 'phone', '');
        const parsed = libphonenumber.parse(phone, 'IN', { extended: true });
        return parsed.valid ? parsed.phone : '';
      },
      set(value) {
        const phone = value.toString();
        const parsed = libphonenumber.parse(phone, 'IN', { extended: true });
        this.employee.phone = parsed.valid
          ? libphonenumber.format(parsed, 'E.164')
          : '';
      }
    }
  },
  methods: {
    _saveEmployee() {
      if (!this.$refs.form.validate()) return;

      firestore
        .collection('tenants')
        .doc(this.$store.state.profile.cid)
        .collection('employees')
        .doc(this.employee.id)
        .update({
          name: this.employee.name,
          phone: this.employee.phone,
          designation: this.employee.designation || null
        });
      this.$emit('update');
    }
  }
};
</script>
